import "./AccountPage.scss";
import {NavLink, Outlet, useNavigate} from "react-router-dom";
import defaultImageProfile from "../../assets/images/default-profile-image.png";
import editIcon from "../../assets/images/icons/edit.svg";
import {Upload} from "antd";
import type {UploadProps} from 'antd';
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import {AuthService} from "../../services/auth.service";
import {getProfileImage} from "../../helpers/image.helper";
import {openMessage} from "../../store/notification/notificationSlice";
import {IModelForUpdateCustomer} from "../../models/Auth";
import {updateProfileAction} from "../../store/profile/profileSlice";

const AccountPage = () => {

    const {profile, isAuthorized} = useAppSelector(state => state.profileSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthorized === false) {
            navigate("/");
        }
    }, [isAuthorized]);

    const props: UploadProps = {
        name: 'files[]',
        accept: ".jpg, .jpeg, .png",
        action: `${activeGym.endpoint}api/general/upload-image`,
        headers: {
            authorization: `Bearer ${AuthService.gwtJWT()}`,
        },
        maxCount: 1,
        onChange: async (info) => {
            if (info.file.status === 'done' && info.file.response?.path && profile) {
                const model: IModelForUpdateCustomer = {
                    id: profile.customerId,
                    dateOfBirth: profile.dateOfBirth,
                    email: profile.email,
                    phone: profile.phone,
                    profileImage: info.file.response.path
                }

                const response = await AuthService.updateProfile(model);

                if (response.status === 200) {
                    dispatch(openMessage({title: t("ImageUpdated"), type: "success"}));
                    dispatch(updateProfileAction(model));
                } else {
                    dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
                }
            } else if (info.file.status === 'error') {
                dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
            }
        },
    };

    return (
        <div className="account-page">
            <div className="container">
                <section className="account-page__top">
                    <div className="avatar-wrapper">
                        <div
                            className="avatar"
                            style={{backgroundImage: `url(${getProfileImage(activeGym.endpoint, profile) ? getProfileImage(activeGym.endpoint, profile) : defaultImageProfile})`}}
                        >
                        </div>
                        <Upload {...props}>
                            <button className="avatar-btn">
                                <img src={editIcon} alt={"Edit"}/>
                            </button>
                        </Upload>
                    </div>
                    <ul className="links-wrapper">
                        <li className="links-wrapper__item">
                            <NavLink className="link" to={"settings"}>{t("Account")}</NavLink>
                        </li>
                        <li className="links-wrapper__item">
                            <NavLink className="link" to={"subscriptions"}>{t("Subscriptions")}</NavLink>
                        </li>
                        <li className="links-wrapper__item">
                            <NavLink className="link" to={"bookings"}>{t("Bookings")}</NavLink>
                        </li>
                        <li className="links-wrapper__item">
                            <NavLink className="link" to={"payment-history"}>{t("PaymentHistory")}</NavLink>
                        </li>
                        <li className="links-wrapper__item">
                            <NavLink className="link" to={"cards"}>{t("MyCards")}</NavLink>
                        </li>
                        {
                            gymSettings?.enableLoyaltyPoints && (
                                <li className="links-wrapper__item">
                                    <NavLink className="link" to={"loyalty-points"}>{t("LoyaltyPoints")}</NavLink>
                                </li>
                            )
                        }
                    </ul>
                </section>
            </div>

            <div className="border"></div>

            <Outlet/>

        </div>
    )
}

export default AccountPage;